const EXPIRATION_TIMEOUT = 600000

class GooglePlacesSessionTokenStore {
    getToken() {
        if (!this._token) {
            this._token = new window.google.maps.places.AutocompleteSessionToken()
            this._timeout = setTimeout(() => this.clearToken(), EXPIRATION_TIMEOUT)
        }

        return this._token
    }

    clearToken() {
        this._token = null
        clearTimeout(this._timeout)
    }
}

const store = new GooglePlacesSessionTokenStore()
export default store


// WEBPACK FOOTER //
// ./web/js/controls/GooglePlacesSessionTokenStore.js